import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import metaBizNode from '../../metaBizNode.mjs'

const FM_NAME = metaBizNode.FM.name

export const canAiGenerateFamdt = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                pkid &&
                prjId === this.data.prjId &&
                /^(FM)$/.test(bizNodeType)
            )
        })
    }
}

export const aiGenerateFamdt = () => () => {
    const openModal = useOpenModal()

    return async function (nodes) {
        const ns = this.commands.canAiGenerateFamdt(nodes)

        if (0 === ns.length) {
            await openModal(
                <Alert type="error">
                    请先选择{FM_NAME}
                </Alert>
            )

            return
        }

        if (ns.length < [...nodes].length) {
            await openModal(
                <Alert type="warn">
                    选中的节点有些不是{FM_NAME}，它们将被忽略
                </Alert>
            )
        }

        const {prjId, sVer} = this.data
        const fmIds = []
        const fmNames = []

        for (const n of ns) {
            const {fmName, pkid} = n.data
            fmIds.push(pkid)
            fmNames.push(fmName)
        }

        const subTitle = `${FM_NAME}: ${fmNames.join(', ')}`

        openWindow(
            '/Ai',

            {
                bizMap: {fmIds},
                prjId,
                scene: 'GENERATE_FAMDT',
                subTitle,
                sVer,
            }
        )
    }
}
